import React from 'react';
import { Link } from 'react-router-dom';
import './AppButton.css';

function getButtonClasses(variant = 'primary', size = 'md', fullWidth = false, className = '') {
    return [
        'app-btn',
        `app-btn--${variant}`,
        `app-btn--${size}`,
        fullWidth ? 'app-btn--full' : '',
        className,
    ].filter(Boolean).join(' ');
}

/**
 * props:
 * - variant: 'primary' | 'secondary' | 'logout'
 * - size: 'sm' | 'md' | 'nav' | 'lg'
 * - fullWidth: boolean
 * - className
 * - children
 */
export function AppButton(props) {
    const {
        variant = 'primary',
        size = 'md',
        fullWidth = false,
        className = '',
        children,
        ...rest
    } = props;

    return (
        <button
            type={props.type || 'button'}
            className={getButtonClasses(variant, size, fullWidth, className)}
            {...rest}
        >
            {children}
        </button>
    );
}

/**
 * props:
 * - to
 * - variant
 * - size
 * - fullWidth
 * - className
 * - children
 */
export function AppButtonLink(props) {
    const {
        to,
        variant = 'primary',
        size = 'md',
        fullWidth = false,
        className = '',
        children,
        onClick,
        ...rest
    } = props;

    return (
        <Link
            to={to}
            className={getButtonClasses(variant, size, fullWidth, className)}
            onClick={onClick}
            {...rest}
        >
            {children}
        </Link>
    );
}

export default AppButton;